import React, { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";

export const GATEWAY_STATES = Object.freeze({
  ARRIVAL: "arrival",
  IDENTITY_ENTRY: "identity-entry",
  IDENTITY_RECOGNITION: "identity-recognition",
  PASSWORD_VERIFICATION: "password-verification",
  SECURITY_VERIFICATION: "security-verification",
  RECOVERY: "recovery",
  REGISTRATION: "registration",
  ACCOUNT_SWITCHING: "account-switching",
  SUCCESS: "success-transition",
  OFFLINE: "offline-recovery",
  ERROR: "error-recovery",
});

const routeState = [
  [/^\/login_2/, GATEWAY_STATES.PASSWORD_VERIFICATION],
  [/^\/login/, GATEWAY_STATES.IDENTITY_ENTRY],
  [/^\/(signup|register|personal-details|choose-mail|create-password|captcha|enter-code|recovery-mail|review-info|register-business|number-of-employee|contact-info|domain|business-information|business-contact-info|sign-in-details|business-enter-code|captcha-business)/, GATEWAY_STATES.REGISTRATION],
  [/^\/(forgot|account-recovery|enter-code-forgot|full-name|verification-code|select-account|email-address|verify-phone-number)/, GATEWAY_STATES.RECOVERY],
  [/^\/select-account/, GATEWAY_STATES.ACCOUNT_SWITCHING],
];

const GatewayStateContext = createContext({ state: GATEWAY_STATES.ARRIVAL, stageIndex: 0, totalStages: 4 });

export function resolveGatewayState(pathname) {
  return routeState.find(([pattern]) => pattern.test(pathname))?.[1] || GATEWAY_STATES.ARRIVAL;
}

export function GatewayStateProvider({ children }) {
  const location = useLocation();
  const value = useMemo(() => {
    const state = resolveGatewayState(location.pathname);
    const stageIndex = {
      [GATEWAY_STATES.ARRIVAL]: 0,
      [GATEWAY_STATES.IDENTITY_ENTRY]: 1,
      [GATEWAY_STATES.IDENTITY_RECOGNITION]: 2,
      [GATEWAY_STATES.PASSWORD_VERIFICATION]: 3,
      [GATEWAY_STATES.SECURITY_VERIFICATION]: 4,
      [GATEWAY_STATES.RECOVERY]: 2,
      [GATEWAY_STATES.REGISTRATION]: 1,
      [GATEWAY_STATES.ACCOUNT_SWITCHING]: 2,
      [GATEWAY_STATES.SUCCESS]: 4,
    }[state] ?? 0;
    return { state, stageIndex, totalStages: 4 };
  }, [location.pathname]);

  return <GatewayStateContext.Provider value={value}>{children}</GatewayStateContext.Provider>;
}

export function useGatewayState() {
  return useContext(GatewayStateContext);
}
